const bannerSlick = (carousel, dots) => {
	if (carousel !== undefined) {
		var settings = {
			arrows: true,
			autoplay: true,
			dots: dots,
			draggable: false,
			infinite: true,
			lazyLoad: 'ondemand',
			speed: 300,
			fade: true,
			autoplaySpeed: 3000,
		};
		try {
			if (typeof window != 'undefined') {
				var theUserAgent = navigator.userAgent;
				var userAgentsWeAreLookingFor = [
					'Googlebot',
					'Chrome-Lighthouse',
					'PTST',
					'AdsBot-Google',
					'DuckDuckBot',
					'Slurp',
					'Baiduspider',
					'YandexBot',
					'Facebot',
					'facebookexternalhit',
					'ia_archiver',
					'LinkedInBot',
					'Google Page Speed Insights',
					'Search Console',
					'Sogou web spider',
					'bingbot',
					'Twitterbot',
					'YandexMobileBot',
					'Pingdom.com_bot',
					'SpeedCurve',
				];
				for (var iUA = 0; iUA < userAgentsWeAreLookingFor.length; iUA++) {
					if (theUserAgent.indexOf(userAgentsWeAreLookingFor[iUA]) > -1) {
						//this is a user agent we want not to autoplay
						settings.autoplay = false;
						break;
					}
				}
			}
		} catch (e) {
			// console.log(e);
		}

		carousel.not('.slick-initialized').slick(settings);
	}
};

const giftCardCarousel = () => {
	if ($('#gift-card-carousel').length > 0) {
		$('#gift-card-carousel')
			.not('.slick-intialized')
			.slick({
				centerMode: true,
				centerPadding: '60px',
				dots: true,
				draggable: false,
				slidesToShow: 3,
				slidesToScroll: 3,
				prevArrow: '<i class="fa fa-angle-left slickCustomPrev" aria-hidden="true"></i>',
				nextArrow: '<i class="fa fa-angle-right slickCustomNext" aria-hidden="true"></i>',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							arrows: false,
							swipe: true,
							swipeToSlide: true,
						},
					},
					{
						breakpoint: 768,
						settings: {
							arrows: false,
							centerPadding: '40px',
							dots: false,
							slidesToShow: 1,
							swipe: true,
							swipeToSlide: true,
						},
					},
				],
			});
	}
};

const chanelCarousel_dt = () => {
	try {
		if ($('#chanelhomepageespot-carousel').length > 0) {
			$('#chanelhomepageespot-carousel').slick({
				arrows: false,
				autoplay: true,
				draggable: false,
				infinite: true,
				speed: 300,
				fade: true,
				autoplaySpeed: 3000,
			});
		}
	} catch (e) {}
};

const genericCarousel_dt = () => {
	if ($('#carousel-example-generic').length > 0) bannerSlick($('#carousel-example-generic'), true);
};

const splashCarousel_dt = () => {
	if ($('#homepage-carousel').length > 0) bannerSlick($('#homepage-carousel'), true);
};

const splashCarousel_mobile = () => {
	if ($('#homepage-carousel').length > 0) bannerSlick($('#homepage-carousel'), true);
};

const otherCarousels = () => {
	giftCardCarousel();
};

const bannerCarousels_dt = () => {
	chanelCarousel_dt();
	genericCarousel_dt();
	otherCarousels();
};

const bannerCarousels_mobile = () => {
	otherCarousels();
};

export { bannerCarousels_dt, bannerCarousels_mobile, splashCarousel_dt, splashCarousel_mobile };
